jQuery(document).ready(function ($) {
  $('[data-slider="card"]').each(function(index, element) {
    var $slider = $(element);
    var sliderId = $slider.attr('id');
    var prevArrowId = 'arrow-prev-' + sliderId.split('-')[1];
    var nextArrowId = 'arrow-next-' + sliderId.split('-')[1];

    // Initialisieren Sie den Slider mit den eindeutigen Pfeilen
    $slider.slick({
      infinite: true,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      prevArrow: $('#' + prevArrowId),
      nextArrow: $('#' + nextArrowId),
      responsive: [
        {
          breakpoint: 768, // Mobile view
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 993, // Desktop view
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 9999, // Larger screens
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  });
});
